"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSource = void 0;
var LocationSource;
(function (LocationSource) {
    LocationSource[LocationSource["Internal"] = 0] = "Internal";
    LocationSource[LocationSource["Google"] = 1] = "Google";
})(LocationSource || (exports.LocationSource = LocationSource = {}));
//# sourceMappingURL=location-source.enum.js.map